// Table.js
import React from "react";
import { cn } from "../../utility/utils";

export const Table = ({ children, className }) => (
  <div className={cn("max-w-full h-full overflow-auto no-scrollbar")}>
    <table
      className={cn(
        "table-auto w-full border-separate border-spacing-y-[8px] -mt-2",
        className
      )}
    >
      {children}
    </table>
  </div>
);

export const TableHead = ({ children }) => (
  <thead>
    <tr className={cn("bg-gray-200 rounded-md")}>{children}</tr>
  </thead>
);

export const TableBody = ({ children }) => <tbody>{children}</tbody>;

export const TableRow = ({ children, onClick, className = "" }) => (
  <tr
    onClick={onClick}
    className={cn(`cursor-pointer bg-white hover:bg-gray-50 ${className}`)}
  >
    {children}
  </tr>
);

export const TableCell = ({ children, className = "", colSpan, ...props }) => (
  <td
    className={cn(`text-dark font-medium text-sm py-3 px-4 ${className}`)}
    colSpan={colSpan}
    {...props}
  >
    {children}
  </td>
);

export const TableHeaderCell = ({ children, className, colSpan, ...props }) => (
  <th
    className={cn(
      `text-sm text-left font-semibold first-of-type:rounded-l-lg last-of-type:rounded-r-lg text-primary py-3 px-4 ${className}`
    )}
    colSpan={colSpan}
    {...props}
  >
    {children}
  </th>
);
